import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { IModule } from 'src/app/interfaces/IModule';
import { paths } from 'src/component-paths/component-paths';
import { DischargeReportService } from 'src/app/services/dischargeReport.service';

@Component({
  selector: 'app-eoc-section',
  templateUrl: './eoc-section.component.html',
  styleUrls: ['./eoc-section.component.css'],
  standalone: false,
})
export class EocSectionComponent implements OnInit, OnDestroy {
  @Input() submenu?: IModule[];

  componentPaths = paths;

  private destroy$ = new Subject<void>();

  isDischargeReportOpen = false;

  constructor(private readonly dischargeReportService: DischargeReportService) {}

  get hasConfiguredSubmenu(): boolean {
    return !!this.submenu?.length;
  }

  ngOnInit(): void {
    this.dischargeReportService.isOpenSub
      .pipe(takeUntil(this.destroy$))
      .subscribe((isOpen) => (this.isDischargeReportOpen = isOpen));
  }

  ngOnDestroy(): void {
    this.dischargeReportService.close();
    this.destroy$.next();
    this.destroy$.complete();
  }
}